import { useSortable } from '@dnd-kit/sortable';
import { useMemo } from 'react';

import { type ConfigViewOption } from '~/store/configViews/types';
import { getSortableItemStyles, visibleHeader } from '~/utils/configurableViewFieldsUtils';

export type ViewVisibilityHeaderProps = {
  option: ConfigViewOption;
  onClick: (nextIsFieldVisible: boolean) => void;
};

const ViewVisibilityHeader = ({ option, onClick }: ViewVisibilityHeaderProps) => {
  const sortableProps = useSortable({
    id: option.derivedId,
    disabled: true,
  });

  const style = useMemo(() => getSortableItemStyles(sortableProps), [sortableProps]);

  return (
    <div
      className="flex cursor-default flex-col"
      ref={sortableProps?.setNodeRef}
      style={style}
      {...sortableProps?.attributes}
      data-no-dnd
    >
      <div className="flex items-center justify-between px-1.5 py-2 font-medium text-12 text-grey-9 leading-[18px]">
        <span>{option.label}</span>
        <button
          className="cursor-pointer text-grey-11"
          onClick={() => onClick(option.derivedId === visibleHeader.derivedId ? false : true)}
          type="button"
        >
          {option.derivedId === visibleHeader.derivedId ? 'Hide all' : 'Show all'}
        </button>
      </div>
    </div>
  );
};

ViewVisibilityHeader.displayName = 'ViewVisibilityHeader';

export default ViewVisibilityHeader;
